export default __webpack_public_path__ + "static/media/8.fa5a3dad.jpg";